"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRateEnquiries = void 0;
const getRateEnquiries = async (supabase) => {
    const { data, error } = await supabase
        .from("rate_enquiries")
        .select(`*,    
        course:courses!course_id(*),
        client:user_profiles!client_id(*)`)
        .order("created_at", { ascending: false });
    if (!error)
        return data;
    return error;
};
exports.getRateEnquiries = getRateEnquiries;
